<template>
	<v-row no-gutters class="px-4">
    <v-row v-if="loading" no-gutters justify="center" align="center" style="height: 600px;">
			<v-progress-circular
				:size="50"
				color="primary"
				indeterminate
			></v-progress-circular>
		</v-row>
    <v-col cols="12">
      <v-row no-gutters class="mb-3">
				<span class="title font-weight-regular primary--text">
					<translate>Appointment Types</translate>
        </span>
      </v-row>
    </v-col>
    <v-col cols="12">
      <v-btn fab color="primary" small @click="showForm = true">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-col>
    <v-dialog v-model="showForm" max-width="40%" scrollable>
      <v-card>
        <v-card-title class="title primary--text mb-2 secondary">
          <translate>Appointment Type</translate>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-row no-gutters class="mt-2">
              <v-col cols="12">
                <v-text-field
                  v-model="appointmentType.name"
                  :label="$gettext('Name')"
                  filled
                  hide-details
                  class="pa-2"
                  :rules="[required]"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" text @click="showForm = false">
            <translate>Cancel</translate>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="createAppointmentType" key="save" :loading="savingAppointmentType">
            <translate>Save</translate>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
		<v-col>
			<p v-if="appointmentTypes.length == 0" class="font-weight-thin ml-5 mt-2" v-translate>
				No appointment types.
			</p>
			<v-list v-else>
        <AppointmentType v-for="appType in appointmentTypes" :key="appType.id" :appType="appType" @remove-appointment-type="removeAppointmentType" />
			</v-list>
		</v-col>
	</v-row>
</template>

<script>
import axios from "axios";
import AppointmentType from "@/components/settings/AppointmentType"

export default {
  name: "AppointmentTypes",
  components: {
    AppointmentType
  },
  data: () => ({
    loading: false,
    appointmentTypes: [],
    showForm: false,
    savingAppointmentType: false,
    appointmentType: {
      name: "",
      price: "0"
    }
  }),
  computed: {
    required() {
      return value => !!value || this.$gettext("Required.");
    }
  },
  methods: {
    createAppointmentType() {
      if(this.$refs.form.validate()) {
        this.savingAppointmentType = true;
        axios
          .post("/appointment-type/new", this.appointmentType, {params: {pricing: false}})
          .then(response => {
            console.log(response.data);
            this.appointmentTypes.push(response.data.appointment_type);
            this.showForm = false;
            this.savingAppointmentType = false;
          })
          .catch(error => {
            console.log(error);
            this.savingAppointmentType = false;
          });
      }
    },
    removeAppointmentType(appType) {
      this.appointmentTypes.splice(this.appointmentTypes.indexOf(appType), 1);
    },
    init() {
      this.loading = true;
      axios
        .get("/appointment-types")
        .then(response => {
          console.log(response.data);
          this.appointmentTypes = response.data.appointment_types;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
          this.loading = false;
        });
    }
  },
  created() {
    this.init()
  }
}
</script>